import UserIcon from '@public/images/cases/e-commerceWebsiteElectronicRetailer/svg/people.svg'

import { Amount, Role, Wrapper } from './styles'
import type { TeamMemberProps } from './types'

export function TeamMember({ amount, role }: TeamMemberProps) {
  return (
    <Wrapper>
      <Amount>
        {amount} <UserIcon />
      </Amount>
      <Role>{role}</Role>
    </Wrapper>
  )
}
